<template>
  <div>
    <a-form-item label="套餐">
      <a-select
        @change="fetchGoodsInfoData"
        :loading="loadingAgentProductOptions"
        show-search
        :filter-option="filterOption"
        v-decorator="[
          'agents_product_id',
          { rules: [{ required: true, message: '请选择套餐' }] },
        ]"
        placeholder="请选择"
      >
        <a-select-option
          v-for="record in agentProductOptions"
          :key="record.id"
          :value="record.id"
        >
          {{ record.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item
      label="卡片材质"
      :style="{ marginBottom: 0 }"
    >
      <a-spin :spinning="loadingCardTypeOptions">
        <a-radio-group
          button-style="solid"
          @change="handleCardTypeChange"
          v-decorator="[
            'card_type_id',
            { rules: [{ required: true, message: '请选择卡片材质' }] }
          ]"
        >
          <a-radio-button
            class="card-select-box card-type-box"
            v-for="cardType in cardTypes"
            :key="cardType.id"
            :value="cardType.id"
          >
            {{ cardType.name }}
          </a-radio-button>
        </a-radio-group>
      </a-spin>
    </a-form-item>

    <a-form-item
      label="卡片尺寸"
      :style="{ marginBottom: 0 }"
    >
      <a-spin :spinning="loadingCardShapeOptions">
        <a-radio-group
          button-style="solid"
          v-decorator="['card_shape_id',{
            rules: [
              { required: true, message: '请选择卡片尺寸' }
            ]
          }]"
        >
          <a-radio-button
            class="card-select-box card-shape-box"
            v-for="cardShape in cardShapeOptions"
            :key="cardShape.id"
            :value="cardShape.id"
          >
            {{ cardShape.name }}
          </a-radio-button>
        </a-radio-group>
      </a-spin>
    </a-form-item>

    <a-form-item
      label="服务周期"
      required="required"
    >
      <a-space>
        <a-input-number
          :step="1"
          style="width: 120px"
          :formatter="parseServicePeriodInputValue"
          :parser="parseServicePeriodInputValue"
          :disabled="isMerchantSales"
          @change="handleServicePeriodChange"
          v-decorator="['service_period', {
            initialValue: minFavorablePriceCycle,
            rules: [
              { validator: checkServicePeriod }
            ]
          }]"
        />
        <span>个周期</span>
      </a-space>
    </a-form-item>

    <a-form-item label="采购卡数" required="required">
      <a-space>
        <a-input-number
          :min="1"
          :max="cardCountMaxValue"
          :step="1"
          :precision="0"
          style="width: 120px"
          :formatter="parseCardCountInputValue"
          :parser="parseCardCountInputValue"
          @change="handleCardCountChange"
          v-decorator="['product_count', {
            rules: [
              { required: true, message: '请输入采购卡数' }
            ]
          }]"
        />
        <span>张</span>
      </a-space>
    </a-form-item>

    <a-form-item label="通信制式">
      <a-select
        :loading="loadingCommModeOptions"
        show-search
        :filter-option="filterOption"
        v-decorator="[
          'comm_mode_id',
          { rules: [{ required: true, message: '请选择通信制式' }] },
        ]"
        placeholder="请选择"
      >
        <a-select-option
          v-for="record in commModeOptions"
          :key="record.sub_type_slug"
          :value="record.id"
        >
          {{ record.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="流量类型">
      <a-select
        :loading="loadingFlowTypeOptions"
        show-search
        :filter-option="filterOption"
        v-decorator="[
          'flow_type_id',
          { rules: [{ required: true, message: '请选择流量类型' }] },
        ]"
        placeholder="请选择"
      >
        <a-select-option
          v-for="record in flowTypeOptions"
          :key="record.sub_type_slug"
          :value="record.id"
        >
          {{ record.name }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="实名认证">
      <a-radio-group
        v-decorator="['is_need_verified',{
          initialValue: false,
          rules: [
            { required: true, message: '请选择实名认证' },
          ]
        }]"
      >
        <a-radio :value="true">
          是
        </a-radio>
        <a-radio :value="false">
          否
        </a-radio>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="沉默期(月)">
      <a-input-number
        :min="0"
        :max="12"
        :step="1"
        style="width: 100%"
        v-decorator="['silent_period', {
          rules: [
            { required: true, message: '请输入沉默期'},
            { type: 'integer', message: `请输入 0 - 12 之间的整数` }
          ]
        }]"
      />
    </a-form-item>

    <a-form-item label="测试流量(MB)">
      <a-input-number
        :min="0"
        :max="102400"
        :step="1"
        :precision="1"
        style="width: 100%"
        v-decorator="['test_traffic', {
          rules: [
            { required: true, message: '测试流量'}
          ]
        }]"
      />
    </a-form-item>

    <a-form-item label="测试期(月)">
      <a-input-number
        :min="0"
        :max="12"
        :step="1"
        style="width: 100%"
        v-decorator="['test_period', {
          rules: [
            { required: true, message: '请输入测试期'},
            { type: 'integer', message: `请输入 0 - 12 之间的整数` }
          ]
        }]"
      />
    </a-form-item>

    <a-form-item label="空白卡自动激活套餐" v-show="userBusinessType == 'merchant_sales'">
      <a-form-item :style="{ display: 'inline-block', width: '55%', marginBottom: 0 }">
        <a-select
          @change="handleActiveProductChange"
          v-decorator="['active_agent_product_id']"
          allow-clear
        >
          <a-select-option
            v-for="option in agentProductOptions"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :style="{ display: 'inline-block', width: '40%', marginLeft:'5px', marginBottom: 0 }">
        <a-space>
          <a-input-number
            :min="1"
            :max="120"
            :step="1"
            :precision="0"
            v-decorator="['active_agent_product_cycles', {
              rules: [
                { required: isSelectedActiveProduct, message: '周期数'}
              ]
            }]"
          />周期
        </a-space>
      </a-form-item>
    </a-form-item>

    <a-form-item label="空白卡定套后沉默期" v-show="userBusinessType == 'merchant_sales'">
      <a-space>
        <a-input-number
          :min="0"
          :max="6"
          :step="1"
          :precision="0"
          v-decorator="['convert_silent_period', {
            rules: [
              { required: userBusinessType == 'merchant_sales', message: '周期数'}
            ]
          }]"
        />月（客户自行激活/订购套餐后重置沉默期）
      </a-space>
    </a-form-item>

    <a-form-item label="空白卡定套后测试期" v-show="userBusinessType == 'merchant_sales'">
      <a-space>
        <a-input-number
          :min="0"
          :max="3"
          :step="1"
          :precision="0"
          v-decorator="['convert_test_period', {
            rules: [
              { required: userBusinessType == 'merchant_sales', message: '周期数'}
            ]
          }]"
        />月（客户自行激活/订购套餐后重置测试期）
      </a-space>
    </a-form-item>

    <a-form-item label="空白卡定套后限额" v-show="userBusinessType == 'merchant_sales'">
      <a-space>
        <a-input-number
          :min="0"
          :max="100000"
          :step="1"
          :precision="0"
          v-decorator="['convert_limit_usage_value', {
            rules: [
              { required: userBusinessType == 'merchant_sales', message: '限额倍数'}
            ]
          }]"
        />倍（同上,0不限/B端3倍/非B端1倍容量）
      </a-space>
    </a-form-item>

    <a-form-item label="产品备注">
      <a-textarea
        v-decorator="['product_remark', {
          rules: [
            { max: 200, message: '最多200个字符' },
          ]
        }]"
        :auto-size="{ minRows: 2, maxRows: 5 }"
      />
    </a-form-item>

    <a-descriptions
      :column="1"
      class="iotplt-descriptions iotplt-descriptions-max-6"
    >
      <a-descriptions-item label="套餐费用(元)">
        {{ productFeeDisplay }}
      </a-descriptions-item>

      <a-descriptions-item label="卡板费用(元)">
        {{ cardFeeDisplay }}
      </a-descriptions-item>

      <a-descriptions-item label="小计(元)">
        {{ totalFeeDisplay }}
      </a-descriptions-item>

      <a-descriptions-item label="账户余额(元)">
        {{ balanceDisplay }}
      </a-descriptions-item>

      <a-descriptions-item label="可用额度(元)">
        {{ availableDisplay }}
      </a-descriptions-item>

      <a-descriptions-item label="已授信(元)">
        {{ creditDisplay }}
      </a-descriptions-item>
    </a-descriptions>

    <a-form-item label="新增授信(元)">
      <a-input-number
        :min="0"
        :max="10000000"
        :step="0.01"
        :precision="2"
        style="width: 100%;"
        v-decorator="['credit', {
          rules: [
            { required: true, message: '请输入授信额度' }
          ]
        }]"
      />
    </a-form-item>
  </div>
</template>

<script>
import { formatFloat } from '@/utils/filter'
import { findCommonTypeOptions } from '@/api/common_type'
import { findAgentsProductsOptions, findGoodsInfo } from '@/api/agents_product'
import { findCardShapeOptions } from '@/api/common_options'
import { calculateAgentPreOrderItemFee } from '@/api/agent_pre_order'
import { findPreOrderItemLastRemarks } from '@/api/agent_pre_order_item'

export default {
  name: 'NewSimCardForm',
  props: {
    form: {
      type: Object,
      required: true
    },
    agentId: {
      type: Number,
      required: true
    },
    productTypeId: {
      type: Number,
      required: true
    },
    financeOverview: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.calculateProductFee = this.$lodash.debounce(this.calculateProductFee, 400)
    return {
      product: {},
      agentProductOptions: [],
      loadingAgentProductOptions: true,
      cardTypes: [],
      loadingCardTypeOptions: false,
      cardShapeOptions: [],
      loadingCardShapeOptions: false,
      agentPorductId: undefined,
      isMerchantSales: false,
      servicePeriodMaxValue: 1000000,
      cardCountMaxValue: 10000000,
      minFavorablePriceCycle: 1,
      maxFavorablePriceCycle: 1,
      productFeeDisplay: '', // 套餐费用
      cardFeeDisplay: '', // 卡板费用
      totalFeeDisplay: '', // 总费用

      commModeOptions: [],
      loadingCommModeOptions: true,
      flowTypeOptions: [],
      loadingFlowTypeOptions: true,
      isSelectedActiveProduct: false,
      userBusinessType: '',
      totalFeeValue: undefined
    }
  },
  computed: {
    balanceDisplay() {
      return this.formatMoney(this.financeOverview.balance)
    },
    availableDisplay() {
      return this.formatMoney(this.financeOverview.available)
    },
    creditDisplay() {
      return this.formatMoney(this.financeOverview.credit)
    }
  },
  created() {
    this.fetchCommModeOptions()
    this.fetchFlowTypeOptions()
  },
  methods: {
    formatMoney(value) {
      if (value === null || value === undefined) {
        return '--'
      }
      return formatFloat(value)
    },
    // 加载通信制式
    fetchCommModeOptions() {
      this.loadingCommModeOptions = true
      findCommonTypeOptions('product_comm_mode').then((res) => {
        if (res.code === 0) {
          this.commModeOptions = res.data
        }
        this.loadingCommModeOptions = false
      })
    },

    // 加载流量类型
    fetchFlowTypeOptions() {
      this.loadingFlowTypeOptions = true
      findCommonTypeOptions('product_flow_type').then((res) => {
        if (res.code === 0) {
          this.flowTypeOptions = res.data
        }
        this.loadingFlowTypeOptions = false
      })
    },

    parseServicePeriodInputValue(val) {
      if (!val) {
        return ''
      }

      if (val >= this.minFavorablePriceCycle) {
        return parseInt(val)
      }

      return val
    },

    parseCardCountInputValue(val) {
      if (!val) {
        return ''
      }

      if (val < 1) {
        val = 1
      } else if (val > this.cardCountMaxValue) {
        val = this.cardCountMaxValue
      }
      return parseInt(val)
    },

    // 加载客户套餐
    fetchAgentProductOptions() {
      this.loadingAgentProductOptions = true
      findAgentsProductsOptions({ agent_id: this.agentId }).then((res) => {
        if (res.code === 0) {
          this.agentProductOptions = res.data
        }
        this.loadingAgentProductOptions = false
      })
    },

    calculateProductFee() {
      if (this.agentPorductId !== undefined) {
        if (this.form.getFieldValue('card_type_id') === undefined ||
          this.form.getFieldValue('product_count') === undefined ||
          this.form.getFieldValue('service_period') === undefined) {
          return
        }
        this.form.validateFields(['service_period', 'product_count'], { force: true }, (err, values) => {
          if (!err) {
            const data = {
              agent_id: this.agentId,
              goods_id: this.agentPorductId,
              service_period: values.service_period,
              product_count: values.product_count,
              card_type_id: this.form.getFieldValue('card_type_id')
            }
            calculateAgentPreOrderItemFee(Object.assign({}, data)).then((res) => {
              if (res.code === 0) {
                const servicePeriod = res.data.service_period
                const cardCount = res.data.product_count

                // 返回结果和当前填的服务周期、材质、卡数不一致, 则不设置值
                if (servicePeriod !== this.form.getFieldValue('service_period') ||
                  cardCount !== this.form.getFieldValue('product_count') ||
                  res.data.card_type_id !== this.form.getFieldValue('card_type_id')) {
                  return
                }

                this.productFeeDisplay = `(${formatFloat(res.data.favorable_prices_distributor_price)} / ${res.data.favorable_prices_cycle}) * ${servicePeriod} * ${cardCount} = ${formatFloat(res.data.product_fee)}`
                this.cardFeeDisplay = `${formatFloat(res.data.card_price)} * ${cardCount} = ${formatFloat(res.data.card_fee)}`
                this.totalFeeDisplay = `${formatFloat(res.data.product_fee)} + ${formatFloat(res.data.card_fee)} = ${formatFloat(res.data.total_fee)}`
                this.totalFeeValue = res.data.total_fee
              }
            })
          }
        })
      }
    },

    fetchGoodsInfoData(value) {
      this.agentPorductId = value
      this.loadingCardTypeOptions = true

      findGoodsInfo(value).then((res) => {
        if (res.code === 0) {
          this.product = res.data

          const agentsProductFavorablePrices = this.product.agents_product_favorable_prices
          this.minFavorablePriceCycle = agentsProductFavorablePrices[0].cycles
          this.maxFavorablePriceCycle = agentsProductFavorablePrices[(agentsProductFavorablePrices).length - 1].cycles

          this.cardTypes = res.data.card_types
          this.loadingCardTypeOptions = false
          const cardTypeId = this.cardTypes[0] ? this.cardTypes[0].id : undefined
          this.form.setFieldsValue({
            card_type_id: cardTypeId
          })

          this.userBusinessType = res.data.user_business_type_slug

          if (this.userBusinessType === 'merchant_sales') {
            this.isMerchantSales = true
          } else {
            this.isMerchantSales = false
          }

          this.fetchCardShapesData(cardTypeId)

          this.fetchPreOrderItemLastRemarks()
        }
      })
    },

    // 加载卡片尺寸
    fetchCardShapesData(cardTypeId) {
      if (cardTypeId) {
        findCardShapeOptions(cardTypeId).then((res) => {
          if (res.code === 0) {
            this.loadingCardShapeOptions = false
            this.cardShapeOptions = res.data
            this.form.setFieldsValue({
              card_shape_id: this.cardShapeOptions[0].id
            })
          }
        })
      }
    },

    // 卡片材质变更，加载卡片尺寸
    handleCardTypeChange(e) {
      this.clearFeeDisplay()
      const cardTypeId = e.target.value
      this.loadingCardShapeOptions = true
      // 清空选项
      this.cardShapeOptions = []
      // 清空选项选中的值
      this.form.setFieldsValue({
        card_shape_id: undefined
      })

      if (cardTypeId) {
        this.fetchCardShapesData(cardTypeId)
        this.calculateProductFee()
      }
    },

    checkServicePeriod(rule, value, callback) {
      if (!value && value !== 0) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入服务周期数')
        return
      }

      if (value > this.servicePeriodMaxValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('服务周期数不大于1000000')
        return
      }

      if (value < this.minFavorablePriceCycle ||
        (value > this.maxFavorablePriceCycle && value % this.maxFavorablePriceCycle !== 0)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(`服务周期需要不小于${this.minFavorablePriceCycle}，或者为${this.maxFavorablePriceCycle}的倍数`)
        return
      }

      callback()
    },

    // 处理改变服务周期值
    handleServicePeriodChange(servicePeriod) {
      this.clearFeeDisplay()
      if (servicePeriod > 0) {
        this.calculateProductFee()
      }
    },

    // 处理改变采购卡数值
    handleCardCountChange(cardCount) {
      this.clearFeeDisplay()
      if (cardCount > 0) {
        this.calculateProductFee()
      }
    },

    handleActiveProductChange(productId) {
      if (productId !== undefined) {
        this.isSelectedActiveProduct = true
      } else {
        this.isSelectedActiveProduct = false
      }
    },

    clearFeeDisplay() {
      this.productFeeDisplay = ''
      this.cardFeeDisplay = ''
      this.totalFeeDisplay = ''
      this.totalFeeValue = undefined
    },

    fetchPreOrderItemLastRemarks() {
      findPreOrderItemLastRemarks({
        agent_id: this.agentId,
        product_type_id: this.productTypeId,
        product_id: this.agentPorductId
      }).then((res) => {
        if (res.code === 0) {
          this.form.setFieldsValue({
            product_remark: res.data.product_remark,
            delivery_remark: res.data.delivery_remark,
            invoice_remark: res.data.invoice_remark
          })
        }
      })
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>

<style lang="less" scoped>
.card-price-wrapper{
  max-height: 250px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
}

.card-select-box {
  margin: 0 10px 5px 0;
  border-radius: 0 !important;
  border: 1px solid #d9d9d9;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.card-type-box {
    min-width: 115px;
    max-width: 240px;
  }

  &.card-shape-box {
    min-width: 105px;
    max-width: 220px;
  }
}

</style>
